import styled from 'styled-components'

export const CardContainer = styled.div`
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};

  box-shadow: 2px 2px 4px 0px #0000001a;

  padding: 8px 16px 20px 16px;

  .start {
    display: flex;
    align-items: center;

    gap: 6px;

    .fake-chart {
      width: 92px;
      background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
      height: 92px;
      border-radius: 100%;
      flex-shrink: 0;
    }

    .name {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;

      margin-bottom: 2px;
    }

    .infos {
      margin-bottom: 8px;

      color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};

      font-size: 14px;
      font-weight: 500;
      line-height: 18px;

      .info {
        display: inline-block;
      }
    }
  }

  .end {
    display: flex;
    flex-direction: column;
    gap: 8px;

    margin-top: 14px;

    .open-action-modal {
      border: none;
      border-radius: 4px;

      padding: 12px 0;

      width: 100%;

      font-size: 14px;
      font-weight: 600;
      line-height: 130%;

      color: rgb(${({ theme }) => theme.primary.base});
      background-color: ${({ theme }) => (theme.isDark ? 'rgba(255, 102, 0, 0.10)' : '#FFDBC5')};
    }

    .link {
      display: flex;
      justify-content: center;

      font-size: 14px;
      font-weight: 600;
      line-height: 16px;

      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      color: ${({ theme }) => `rgb(${theme.primary.base})`};

      padding: 12px 0;
    }

    .actions-buttons {
      display: none;
    }
  }

  @media only screen and (min-width: 800px) {
    display: flex;
    justify-content: space-between;

    gap: 16px;

    padding: 12px 24px 12px 12px;

    .start {
      gap: 46px;
    }

    .end {
      margin-top: 0;

      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .open-action-modal {
        display: none;
      }

      .link {
        width: 142px;
        padding: 14px 0;

        font-size: 16px;
        line-height: 22px;
      }

      .actions-buttons {
        display: flex;
        gap: 6px;

        .group {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        button {
          width: 24px;
          height: 24px;

          background: none;
          border: none;

          color: rgb(${({ theme }) => theme.grayscale[200]});

          transition: color 0.3s ease;

          :hover {
            color: rgb(${({ theme }) => theme.primary.base});
          }
        }
      }
    }
  }

  @media only screen and (min-width: 1000px) {
    .end {
      gap: 44px;

      .actions-buttons {
        gap: 12px;
        .group {
          gap: 12px;
          flex-direction: row;
        }
      }
    }
  }
`

export const ChartContainer = styled.div`
  width: 94px;
  height: 94px;

  position: relative;

  cursor: pointer;

  .label {
    opacity: 0;
    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    pointer-events: none;

    transition: opacity 300ms ease;

    .value {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;

      text-align: center;
    }

    .text {
      font-size: 10px;
      font-weight: 600;
      line-height: 12px;

      text-align: center;
    }
  }

  .label[data-visible='true'] {
    opacity: 1;
  }

  .chart {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    outline: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0); /* mobile webkit */
  }
`

export const ProgressBar = styled.div<{ progress: number }>`
  height: 20px;

  border-radius: 100px;

  background-color: ${({ theme }) => `rgb(${theme.grayscale[400]})`};

  position: relative;

  .colored-bar {
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 100px;

    width: 100%;
    height: 100%;

    background-color: ${({ theme }) => `rgb(${theme.greenProgress[300]})`};

    overflow: hidden;

    clip-path: inset(0px ${({ progress }) => 100 - progress + '%'} 0px 0px round 100px);

    color: ${({ theme }) => `rgb(${theme.background.high})`};

    font-size: 12px;
    font-weight: 500;
    line-height: 14px;

    animation: grow 1s ease-out;
  }

  .text {
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;

    white-space: nowrap;

    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    color: ${({ theme }) => `rgb(${theme.greenProgress[300]})`};

    &[data-no-progress='true'] {
      color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    }
  }

  @keyframes grow {
    0% {
      clip-path: inset(0px 100% 0px 0px round 100px);
    }
  }
`
